<template>
  <div>
    <div class="defect-loader">
      <div class="test-form mt-1">
        <b-row>
          <!-- first name -->
          <b-col cols="4" class="mb-1">
            <b-skeleton class="assign"></b-skeleton>
            <b-skeleton class="suit-content1"></b-skeleton>
          </b-col>
          <b-col cols="4">
            <b-skeleton class="assign"></b-skeleton>
            <b-skeleton class="suit-content1"></b-skeleton>
          </b-col>

          <b-col cols="4" class="project-select">
            <b-skeleton class="assign"></b-skeleton>
            <b-skeleton class="suit-content1"></b-skeleton>
          </b-col>

          <b-col cols="4" class="project-select">
            <b-skeleton class="assign"></b-skeleton>
            <b-skeleton class="suit-content1"></b-skeleton>
          </b-col>
        </b-row>
        <!-- <h4>No contact added yet</h4>-->
      </div>
      <div class="test-form mt-1">
        <b-row>
          <b-col cols="12">
            <b-skeleton class="assign"></b-skeleton>
            <b-skeleton class="suit-content1"></b-skeleton>
          </b-col>
        </b-row>
        <!-- <h4>No contact added yet</h4> -->
      </div>
      <div class="test-form mt-1">
        <b-row>
          <b-col>
            <div>
              <b-skeleton class="assign"></b-skeleton>
              <b-skeleton class="suit-content1"></b-skeleton>
            </div>
          </b-col>
        </b-row>
        <!-- <h4>No contact added yet</h4> -->
      </div>
      <div class="test-form mt-1">
        <b-row>
          <b-col cols="12">
            <b-skeleton class="assign"></b-skeleton>
            <b-skeleton class="suit-content1"></b-skeleton>
          </b-col>
        </b-row>
        <!-- <h4>No contact added yet</h4> -->
      </div>

      <div class="test-form mt-1">
        <div class="scenario-steps view-steps">
          <b-row>
            <b-col cols="12">
              <b-skeleton class="assign"></b-skeleton>
              <b-skeleton class="suit-content1"></b-skeleton>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="test-form mt-1">
        <div class="scenario-steps view-steps">
          <b-skeleton class="assign"></b-skeleton>
          <b-row>
            <b-col cols="12">
              <b-skeleton class="suit-content1"></b-skeleton>
              <b-skeleton class="assign"></b-skeleton>
              <b-skeleton class="suit-content1"></b-skeleton>
              <b-skeleton class="assign"></b-skeleton>
              <b-skeleton class="suit-content1"></b-skeleton>
              <b-skeleton class="assign"></b-skeleton>
              <b-skeleton class="suit-content1"></b-skeleton>
              <b-skeleton class="assign"></b-skeleton>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <div class="d-flex mt-1">
      <b-skeleton class="shimmer-btn mr-1"></b-skeleton>
      <b-skeleton class="shimmer-btn"></b-skeleton>
    </div>
  </div>
</template>

<script>

export default {
  name: "DefectViewLoader",
 
}
</script>

<style>
.shimmer-btn {
  width: 150px;
  height: 40px;
}
.board-card-shimmer {
  width: 100% !important;
}
.tag {
  width: 40px;
  margin-right: 5px;
}
.assign {
  width: 100px;
}
.board-shimmer {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
  padding: 0;
  max-width: 100%;
}
.suit-content1 {
  width: 100%;
  height: 20px;
}
.right-content {
  width: 100%;
  height: 40px;
}
.board-card-shimmer {
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
  padding: 20px;
}
</style>
